/**
 * Calculates a view height and view width from window size and sets them as properties in the document style.
 */
export const calculateAndSetViewSize = () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  let vw = window.innerWidth * 0.01;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
};

/**
 * Generates a random int number between 0 and provided max value (excluded).
 * @param {number} max the maximum value (excluded)
 * @returns {number} random int number
 */
export const getRandomInt = (max) => {
  return Math.floor(Math.random() * max);
};

/**
 * Creates an image object with provided source as src and loads it.
 * @param {string} src source of image to load
 * @returns {Promise<HTMLImageElement>} promise resolving with loaded image
 */
const loadImagePromise = async (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load ${src}`));
    img.src = src;
  });
};

/**
 * Loads an image from provided source.
 * @param {string} src source of image to load
 * @returns {HTMLImageElement} loaded image
 */
export const loadImage = async (src) => {
  try {
    return await loadImagePromise(src);
  } catch (err) {
    console.error(err);
    return null;
  }
};

/**
 * Checks if the current date is the same or after the provided release date.
 * @param {string} release the date to compare to (default: 2023/06/22 00:00:00)
 * @returns {boolean} true if the current date is the same or after the provided release date
 */
export const isAfterReleaseDate = (release = '2023-06-22T00:00:00') => {
  const releaseDate = new Date(release);
  const today = new Date();
  return releaseDate <= today;
};
